import React, { useContext } from 'react';
import { compose } from 'recompose';
import { observer } from 'mobx-react';

import { ConfigurationType } from '../../config/configurationPages';
import ConfigurationMenuContext, { withConfigurationMenuContext } from '../../context/ConfigurationMenuContext';

import ConfigurationList from './components/ConfigurationList';
import HabitCustomization from './components/HabitCustomization';
import CheckoutPageConfiguration from './components/CheckoutPageConfiguration';
import WelcomeMessageConfig from './components/WelcomeMessageConfig';
import LibraryDocumentsConfig from './components/LibraryDocumentsConfig';
import OnboardingMessagesConfig from './components/OnboardingMessagesConfig';
import CheckInCustomization from './components/CheckInCustomization';
import PaymentConfiguration from './components/PaymentConfiguration/PaymentConfiguration';
import ProductsConfig from './components/ProductsConfig';
import ProfileSettings from './components/ProfileSettings';
import NotificationSettings from './components/NotificationSettings';
import InstagramSettings from './components/InstagramSettings';
import OtherSettings from './components/OtherSettings';
import WeeklyMessage from './components/WeeklyMessage';
import AIPromptSettings from './components/AIPromptSettings';
import CheckInFeedbackSettings from './components/CheckInFeedbackSettings';
import FormSettings from './components/FormSettings/FormSettings';
import BirthdayMessageConfig from './components/BirthdayMessageConfig';
import UpsellSettings from './components/UpsellSettings';
import { ConfigContainer } from './styles';

const Config = () => {
  const { selectedConfiguration } = useContext(ConfigurationMenuContext);

  return (
    <ConfigContainer>
      <ConfigurationList />
      {selectedConfiguration === ConfigurationType.HABITS && <HabitCustomization />}
      {selectedConfiguration === ConfigurationType.CHECK_IN && <CheckInCustomization />}
      {selectedConfiguration === ConfigurationType.PAYMENT && <PaymentConfiguration />}
      {selectedConfiguration === ConfigurationType.CHECKOUT_PAGE && <CheckoutPageConfiguration />}
      {selectedConfiguration === ConfigurationType.WELCOME_MESSAGE && <WelcomeMessageConfig />}
      {selectedConfiguration === ConfigurationType.LIBRARY_DOCUMENTS && <LibraryDocumentsConfig />}
      {selectedConfiguration === ConfigurationType.ONBOARDING_MESSAGES && <OnboardingMessagesConfig />}
      {selectedConfiguration === ConfigurationType.CLIENT_JOURNEY_WEEKLY_MESSAGE && <WeeklyMessage />}
      {selectedConfiguration === ConfigurationType.PRODUCTS && <ProductsConfig />}
      {selectedConfiguration === ConfigurationType.PROFILE_SETTINGS && <ProfileSettings />}
      {selectedConfiguration === ConfigurationType.NOTIFICATION_SETTINGS && <NotificationSettings />}
      {selectedConfiguration === ConfigurationType.INSTAGRAM_SETTINGS && <InstagramSettings />}
      {selectedConfiguration === ConfigurationType.OTHER_SETTINGS && <OtherSettings />}
      {selectedConfiguration === ConfigurationType.AI_PROMPT_SETTINGS && <AIPromptSettings />}
      {selectedConfiguration === ConfigurationType.CHECK_IN_FEEDBACK_SETTINGS && <CheckInFeedbackSettings />}
      {selectedConfiguration === ConfigurationType.FORM_SETTINGS && <FormSettings />}
      {selectedConfiguration === ConfigurationType.BIRTHDAY_MESSAGE && <BirthdayMessageConfig />}
      {selectedConfiguration === ConfigurationType.UPSELL_SETTINGS && <UpsellSettings />}
    </ConfigContainer>
  );
};

export default compose(
  withConfigurationMenuContext,
  observer,
)(Config);
